import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);


const staticRouterList = [
  {
    path: '/user/share',
    name: 'share',
    component: ()=> import ('@/views/user/share.vue')
  }
]

export default new Router({
  mode: 'history',
  base: '/',
  // base: '/mshop-mobile-test',
  // routes: staticRouterList
})



// WEBPACK FOOTER //
// ./src/router/index.js